// @flow

import { ADD_CUSTOM_FILTER, REMOVE_CUSTOM_FILTER } from '../../constants';
import type { CustomFilters } from '../../types';
import type { AddCustomFilterAction, RemoveCustomFilterAction } from '../../actions';

export type CustomFilterState = CustomFilters;

const initialState: CustomFilterState = [];

const customFilter = (
  state: CustomFilterState = initialState,
  action: AddCustomFilterAction | RemoveCustomFilterAction,
): CustomFilterState => {
  switch (action.type) {
    case ADD_CUSTOM_FILTER:
      return state.concat([action.payload.key]);
    case REMOVE_CUSTOM_FILTER: {
      const index = state.indexOf(action.payload.key);
      return state.slice(index, index);
    }
    default:
      return state;
  }
};

export default customFilter;
